module.exports = __webpack_public_path__ + "img/quattrocento+quattrocento_sans.4996f7db.png";